// extracted by mini-css-extract-plugin
export var statItem = "_im-1";
export var statsRow = "_im-0";